import { EventBus } from '../core/EventBus.js';
import { GameState } from '../core/GameState.js';
import { SCHEDULE } from '../config/routeStatus.js';

// Keeps route-line colours fresh (#53-T8). Restyle only, never geometry.

const SHIP_EVENTS = [
  'ship:fuelChanged', 'ship:conditionChanged', 'ship:handlingChanged',
  'ship:maintenanceChanged', 'cargo:loaded', 'cargo:unloaded'
];
const ALL_EVENTS = ['contracts:updated', 'time:dayPassed'];

/**
 * @param {{ restyle(ship):void, restyleAll(ships):void }} routeRenderer
 * @param {{ bus?, getShip?, getAllShips?, now?, throttleMs? }} [deps] test overrides
 * @returns {() => void} unsubscribe
 */
export function initRouteStyleSync(routeRenderer, deps = {}) {
  const bus = deps.bus || EventBus;
  const getShip = deps.getShip || ((id) => GameState.getShip(id));
  const getAllShips = deps.getAllShips || (() => GameState.getAllShips());
  const now = deps.now || (() => Date.now());
  const throttleMs = deps.throttleMs ?? SCHEDULE.STYLE_REFRESH_MS;

  const onShip = (e) => {
    const ship = e?.ship || (e?.shipId != null ? getShip(e.shipId) : null);
    if (ship) routeRenderer.restyle(ship);
  };
  const onAll = () => routeRenderer.restyleAll(getAllShips());
  let last = -Infinity;
  const onTick = () => {
    const t = now();
    if (t - last < throttleMs) return;
    last = t;
    onAll();
  };

  const subs = [
    ...SHIP_EVENTS.map(ev => [ev, onShip]),
    ...ALL_EVENTS.map(ev => [ev, onAll]),
    ['time:tick', onTick]
  ];
  for (const [ev, fn] of subs) bus.on(ev, fn);
  return () => { for (const [ev, fn] of subs) bus.off(ev, fn); };
}
